module.exports = __webpack_public_path__ + "img/ManyOrcas.9894e343.svg";